import { connector } from './store';
import dispatchAwaitableAction from './store/operations/dispatch-awaitable-action';
import awaitableActionResolver from './store/middleware/awaitable-action-resolver';
import config from './config';
import clipboard from './clipboard';
import auth from './auth';
import constraints from './constraints';
import history from './history';
import middleware from './middleware';
import viewReloader from './view/middleware/view-reloader';
import reducer from './reducer';
import site from './site';
import saving from './saving';
import view from './view';
import hdrm from './hdrm';
import extensions from './extensions';
import elementSettings from './element-settings';
import blocks from './blocks';
import blockTemplates from './block-templates';
import interrupter from './interrupter';
import integration from './integration';
import dialogs from './dialogs';
import serviceClient from './service-client/service-client';
import assets from './assets';
import globals from './globals';
import errors from './errors';
import i18n from './i18n';
import textFormatting from './text-formatting';
import initializeEvents from './utils/initialize-events';
import contentEditable from './content-editable';
import siteLocales from './site-locales';
import customization from './customization';
import logger from './logger';
import loggerFactory from './logger-factory';
import linkEditing from './link-editing';
import transactions from './transactions';
import template from './template';
import cssGenerator from './css-generator';
import customHtml from './custom-html';

export default {
  auth,
  assets,
  blocks,
  blockTemplates,
  serviceClient,
  config,
  clipboard,
  connector,
  constraints,
  dialogs,
  extensions,
  elementSettings,
  globals,
  hdrm,
  history,
  interrupter,
  integration,
  middleware,
  textFormatting,
  reducer,
  saving,
  site,
  view,
  errors,
  i18n,
  contentEditable,
  viewReloader,
  siteLocales,
  customization,
  logger,
  loggerFactory,
  linkEditing,
  transactions,
  template,
  cssGenerator,
  customHtml,
  dispatchAwaitableAction,
  awaitableActionResolver,
};

initializeEvents();
